import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinwagholipune() {



    const cardData = {

keyword: "Cab Service in Wagholi Pune",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Wagholi Pune for daily commuting, airport transfers, corporate travel, and family trips. We provide quick pickup, safe rides, and well-maintained Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, and luxury cars with professional drivers. Our Wagholi cab service is available 24/7 with transparent pricing and comfortable travel experience. We also offer one-way and outstation cab services from Wagholi to major destinations like Mumbai, Shirdi, Nashik, Goa, Lonavala, and more across Maharashtra and India.",

topPlaces: [
    {
        title: "Ganpatipule",
        description:
            " is a serene coastal town known for its pristine beach and the famous Swayambhu Ganpati Temple. It offers peaceful sea views, clean shores, and a calm spiritual atmosphere ideal for relaxing vacations."
    },
    {
        title: "Tarkarli",
        description:
            " is famous for crystal-clear waters, white sand beaches, and thrilling scuba diving and snorkeling experiences. It is one of the best destinations in Maharashtra for marine adventure tourism."
    },
    {
        title: "Ratnagiri",
        description:
            " is a coastal city known for beaches, mango orchards (Alphonso mangoes), historic forts, and scenic sea cliffs along the Konkan coast."
    },
    {
        title: "Sindhudurg Fort",
        description:
            " is a historic sea fort built by Chhatrapati Shivaji Maharaj, located on an island off the Malvan coast. It is known for its architecture, history, and sea views."
    },
    {
        title: "Dapoli",
        description:
            " is a coastal hill station offering beaches, coconut groves, and dolphin-spotting experiences. It combines sea views with a cooler climate, making it a unique Konkan getaway."
    },
    {
        title: "Alibaug",
        description:
            " is a popular beach destination near Mumbai known for forts, clean beaches, ferry rides, and weekend relaxation with seafood and sunset views."
    },
    {
        title: "Kolhapur",
        description:
            " is a cultural city famous for the Mahalaxmi Temple, Kolhapuri cuisine, leather footwear, and rich Maratha heritage and history."
    },
    {
        title: "Amboli",
        description:
            " is a monsoon hill station in the Sahyadri range known for waterfalls, misty forests, biodiversity, and cool weather, making it a hidden gem in Maharashtra."
    },
    {
        title: "Malvan",
        description:
            " is a coastal town famous for Tarkarli beach nearby, scuba diving, Sindhudurg Fort access, and delicious Malvani seafood cuisine."
    },
    {
        title: "Bhandardara",
        description:
            " is a peaceful lakeside village surrounded by mountains, waterfalls, and Arthur Lake. It is ideal for camping, stargazing, and nature retreats away from city life."
    }
],



services: [
    {
        name: "Taxi Service in Wagholi Pune",
        description:
            "Rising Cab Service offers Taxi Service in Wagholi Pune for residents, IT professionals, students, and business travelers looking for safe, reliable, and comfortable transportation. We provide well-maintained AC vehicles, experienced drivers, and 24x7 availability for local travel, airport transfers, and outstation trips. Our service ensures punctual pickups, smooth rides, and affordable pricing across Wagholi and Pune city."
    },
    {
        name: "Wagholi Cab Service",
        description:
            "Our Wagholi Cab Service ensures quick, safe, and convenient transportation for daily commuters, families, and corporate travelers. Rising Cab Service offers clean vehicles, professional chauffeurs, and flexible booking options for local rides, office travel, and intercity journeys with complete reliability and comfort."
    },
    {
        name: "Wagholi Taxi Service",
        description:
            "Rising Cab Service provides Wagholi Taxi Service with comfortable and affordable rides across Pune and Maharashtra. Whether it is a short city trip or a long-distance journey, our experienced drivers ensure safe travel, timely pickup, and smooth travel experience for all passengers."
    },
    {
        name: "Best Cab Service in Wagholi",
        description:
            "Book Best Cab Service in Wagholi with Rising Cab Service for premium transportation, transparent pricing, and 24x7 support. We offer high-quality service with well-maintained vehicles and professional drivers suitable for families, corporate clients, students, and solo travelers."
    },
    {
        name: "Online Cab Booking Wagholi",
        description:
            "Our Online Cab Booking Wagholi system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for both local and outstation travel needs."
    },
    {
        name: "Cab Hire in Wagholi",
        description:
            "Rising Cab Service offers Cab Hire in Wagholi for hourly rentals, full-day trips, corporate travel, airport transfers, and personal transportation needs. We provide flexible packages with professional drivers and comfortable vehicles for a smooth travel experience."
    },
    {
        name: "Taxi Booking Wagholi",
        description:
            "Book Taxi Booking Wagholi with Rising Cab Service for fast, reliable, and affordable transportation. We ensure timely service, clean vehicles, and experienced drivers for all types of travel requirements including local and outstation trips."
    },
    {
        name: "Outstation Cab Service Wagholi",
        description:
            "Rising Cab Service provides Outstation Cab Service Wagholi for long-distance travel to popular destinations like Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Kolhapur, Pandharpur, Bhimashankar, and Aurangabad. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options for safe intercity travel."
    },
    {
        name: "Wagholi to Mumbai Cab",
        description:
            "Rising Cab Service offers Wagholi to Mumbai Cab for safe and comfortable intercity travel with experienced drivers, smooth highway rides, and flexible booking options for business and leisure trips."
    },
    {
        name: "Wagholi to Shirdi Cab",
        description:
            "Book Wagholi to Shirdi Cab with Rising Cab Service for a peaceful pilgrimage journey to Sai Baba temple with clean vehicles and reliable service for families and devotees."
    },
    {
        name: "Wagholi to Nashik Cab",
        description:
            "Our Wagholi to Nashik Cab service ensures safe and comfortable travel for family trips, pilgrimages, and business journeys with professional drivers and smooth transportation."
    },
    {
        name: "Wagholi to Goa Cab",
        description:
            "Rising Cab Service provides Wagholi to Goa Cab for a relaxing beach vacation with safe driving, comfortable vehicles, and smooth long-distance travel experience."
    },
    {
        name: "Wagholi to Mahabaleshwar Cab",
        description:
            "Book Wagholi to Mahabaleshwar Cab for scenic hill station travel with experienced chauffeurs and comfortable rides suitable for families and couples."
    },
    {
        name: "Wagholi to Lonavala Cab",
        description:
            "Rising Cab Service offers Wagholi to Lonavala Cab for quick weekend getaways with safe, affordable, and comfortable transportation."
    },
    {
        name: "Wagholi to Kolhapur Cab",
        description:
            "Our Wagholi to Kolhapur Cab service ensures smooth pilgrimage and family travel with reliable drivers and well-maintained vehicles."
    },
    {
        name: "Wagholi to Pandharpur Cab",
        description:
            "Rising Cab Service provides Wagholi to Pandharpur Cab for devotees visiting Lord Vitthal temple with comfortable and safe travel arrangements."
    },
    {
        name: "Wagholi to Bhimashankar Cab",
        description:
            "Book Wagholi to Bhimashankar Cab for a spiritual Jyotirlinga pilgrimage with safe driving and experienced chauffeurs."
    },
    {
        name: "Wagholi to Aurangabad Cab",
        description:
            "Rising Cab Service offers Wagholi to Aurangabad Cab for heritage and tourism travel with professional drivers and reliable intercity service."
    },
    {
        name: "Innova Crysta on Rent in Wagholi",
        description:
            "Book Innova Crysta on Rent in Wagholi with Rising Cab Service for premium comfort, spacious seating, and luxury travel experience ideal for family and group trips."
    },
    {
        name: "Ertiga Cab Service Wagholi",
        description:
            "Rising Cab Service offers Ertiga Cab Service Wagholi for affordable and comfortable family travel with clean vehicles and professional drivers."
    },
    {
        name: "Swift Dzire Cab Service Wagholi",
        description:
            "Our Swift Dzire Cab Service Wagholi provides economical and comfortable rides ideal for daily commuting, city travel, and short-distance trips."
    },
    {
        name: "Sedan Cab Service Wagholi",
        description:
            "Rising Cab Service offers Sedan Cab Service Wagholi for budget-friendly and comfortable travel with well-maintained cars and experienced drivers."
    },
    {
        name: "Luxury Car Rental Wagholi",
        description:
            "Book Luxury Car Rental Wagholi with Rising Cab Service for premium travel experience with high-end vehicles, professional chauffeurs, and comfortable rides for special occasions and corporate travel."
    },
    {
        name: "Innova Cab Service Wagholi",
        description:
            "Our Innova Cab Service Wagholi ensures spacious and comfortable group travel with smooth rides and reliable intercity transportation."
    },
    {
        name: "Kia Carens Cab Service Wagholi",
        description:
            "Rising Cab Service offers Kia Carens Cab Service Wagholi for modern, safe, and comfortable family travel with professional drivers and clean vehicles."
    },
    {
        name: "Cab Service in Wagholi Pune",
        description:
            "Rising Cab Service provides Cab Service in Wagholi Pune for reliable local and intercity transportation with 24x7 availability and affordable pricing."
    },
    {
        name: "Taxi Service in Wagholi Pune",
        description:
            "Our Taxi Service in Wagholi Pune ensures safe and comfortable travel across Pune city and outstation routes with experienced drivers and quick response time."
    },
    {
        name: "Wagholi to Pune Airport Cab",
        description:
            "Rising Cab Service offers Wagholi to Pune Airport Cab with timely pickups, comfortable AC vehicles, and stress-free airport transfers at any time of the day."
    },
    {
        name: "Pune Airport to Wagholi Cab",
        description:
            "Book Pune Airport to Wagholi Cab with Rising Cab Service for quick and reliable pickup service with safe and comfortable travel experience."
    },
    {
        name: "Airport Cab Service Wagholi",
        description:
            "Our Airport Cab Service Wagholi ensures smooth and punctual airport transfers with professional drivers and 24x7 availability for arrivals and departures."
    },
    {
        name: "Corporate Cab Service in Wagholi",
        description:
            "Rising Cab Service provides Corporate Cab Service in Wagholi for employee transportation, business travel, and office commuting with reliable and professional service."
    },
    {
        name: "One Way Cab Service Wagholi",
        description:
            "Book One Way Cab Service Wagholi with Rising Cab Service for affordable drop-only travel without return charges and flexible destination options."
    }
],

tableData: [
    ["Taxi Service in Wagholi Pune", "Wagholi Cab Service"],
    ["Wagholi Taxi Service", "Best Cab Service in Wagholi"],
    ["Online Cab Booking Wagholi", "Cab Hire in Wagholi"],
    ["Taxi Booking Wagholi", "Outstation Cab Service Wagholi"],
    ["Wagholi to Mumbai Cab", "Wagholi to Shirdi Cab"],
    ["Wagholi to Nashik Cab", "Wagholi to Goa Cab"],
    ["Wagholi to Mahabaleshwar Cab", "Wagholi to Lonavala Cab"],
    ["Wagholi to Kolhapur Cab", "Wagholi to Pandharpur Cab"],
    ["Wagholi to Bhimashankar Cab", "Wagholi to Aurangabad Cab"],
    ["Innova Crysta on Rent in Wagholi", "Ertiga Cab Service Wagholi"],
    ["Swift Dzire Cab Service Wagholi", "Sedan Cab Service Wagholi"],
    ["Luxury Car Rental Wagholi", "Innova Cab Service Wagholi"],
    ["Kia Carens Cab Service Wagholi", "Cab Service in Wagholi Pune"],
    ["Taxi Service in Wagholi Pune", "Wagholi to Pune Airport Cab"],
    ["Pune Airport to Wagholi Cab", "Airport Cab Service Wagholi"],
    ["Corporate Cab Service in Wagholi", "One Way Cab Service Wagholi"]
],





whychoose: [
    {
        WhyChooseheading: "Dependable Travel Services Throughout Wagholi",
        WhyChoosedescription: "Rising Cab Service offers convenient transportation solutions for residents, office commuters, students, tourists, and families traveling from Wagholi to various destinations."
    },
    {
        WhyChooseheading: "Excellent Connectivity to IT and Business Hubs",
        WhyChoosedescription: "Travel comfortably from Wagholi to Kharadi, EON IT Park, World Trade Center, Hadapsar, Magarpatta, Viman Nagar, and other commercial areas."
    },
    {
        WhyChooseheading: "Suitable for Daily and Special Travel Needs",
        WhyChoosedescription: "Whether planning an airport transfer, office commute, family function, medical visit, sightseeing tour, or outstation journey, we provide suitable travel options."
    },
    {
        WhyChooseheading: "Vehicle Choices for Every Travel Requirement",
        WhyChoosedescription: "Customers can select from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger requirements."
    },
    {
        WhyChooseheading: "Quick Pickup from Residential and Commercial Areas",
        WhyChoosedescription: "Our cab service covers housing societies, educational institutions, offices, hotels, hospitals, and major landmarks across Wagholi."
    },
    {
        WhyChooseheading: "Travel Planning Made Easy",
        WhyChoosedescription: "From short-distance city rides to long outstation tours, our team helps customers choose the most convenient travel arrangement."
    },
    {
        WhyChooseheading: "Comfort-Oriented Travel Experience",
        WhyChoosedescription: "Every vehicle is maintained for cleanliness and comfort, allowing passengers to enjoy stress-free journeys throughout their trip."
    },
    {
        WhyChooseheading: "Widely Chosen by Families and Professionals",
        WhyChoosedescription: "Rising Cab Service serves working professionals, business travelers, senior citizens, tourists, and families looking for reliable transportation."
    }
]
};

const faqData = [
    {
        question: "Which destinations are commonly visited from Wagholi using your cab service?",
        answer: "Customers frequently travel to Pune Airport, Kharadi, Hadapsar, Magarpatta, Hinjewadi, Mumbai, Shirdi, Lonavala, Mahabaleshwar, and many other locations."
    },
    {
        question: "Is airport transportation available from Wagholi?",
        answer: "Yes, we provide comfortable and timely airport pickup and drop services between Wagholi and Pune Airport."
    },
    {
        question: "Can office employees arrange transportation from Wagholi?",
        answer: "Yes, many professionals working in nearby IT parks and business centers use our service for daily commuting."
    },
    {
        question: "What vehicle categories are available for booking?",
        answer: "Our fleet includes Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, Mini Buses, and luxury vehicles."
    },
    {
        question: "Do you provide outstation cab services from Wagholi?",
        answer: "Yes, customers can hire vehicles for one-way and round-trip journeys to destinations across Maharashtra and neighboring states."
    },
    {
        question: "Can larger groups hire Tempo Travellers or buses?",
        answer: "Yes, group transportation options are available for family tours, corporate outings, weddings, and special events."
    },
    {
        question: "Is advance booking recommended for weekends?",
        answer: "Yes, reserving your vehicle in advance helps ensure availability during weekends, holidays, and peak travel periods."
    },
    {
        question: "Can customers book vehicles for a full day?",
        answer: "Yes, full-day cab rentals are available for business visits, local travel, sightseeing tours, and personal requirements."
    },
    {
        question: "Are one-way rides available from Wagholi?",
        answer: "Yes, customers can choose both one-way and round-trip travel options based on their plans."
    },
    {
        question: "How can I arrange a cab in Wagholi?",
        answer: "You can schedule your ride through a phone call, WhatsApp message, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nikhil Kale",
        feedback:
            "Daily travel between Wagholi and Kharadi became much more convenient after switching to Rising Cab Service. The professionalism and punctuality have remained consistently impressive.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Dipali Shirsat",
        feedback:
            "For a recent outstation family trip, the arrangements were handled exceptionally well. The vehicle was comfortable, and the journey was smooth from departure to return.",
        rating: 5
    }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Wagholi Pune",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-wagholi-pune.jpg",
"description": "Book Cab Service in Wagholi Pune with Rising Cab Service for local travel, airport transfers, corporate rides, and outstation trips. Enjoy safe, affordable, and reliable taxi service in Wagholi with AC cars and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-wagholi-pune"
}
};






    return (
        <div>


<Helmet>
  <title>Cab Service in Wagholi Pune | Local & Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Wagholi Pune for local rides, airport transfers, corporate travel, and outstation trips. Affordable taxi service with AC cabs and professional drivers for safe and comfortable journeys."
/>

<meta
 name="keywords"
 content="Taxi Service in Wagholi Pune, Wagholi Cab Service, Wagholi Taxi Service, Best Cab Service in Wagholi, Online Cab Booking Wagholi, Cab Hire in Wagholi, Taxi Booking Wagholi, Outstation Cab Service Wagholi, Wagholi to Mumbai Cab, Wagholi to Shirdi Cab, Wagholi to Nashik Cab, Wagholi to Goa Cab, Wagholi to Mahabaleshwar Cab, Wagholi to Lonavala Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinwagholipune;